import React, { memo, useMemo } from 'react';

/**
 * DeliverablesCell - Displays deliverables count and completion status
 * Memoized to prevent re-renders when other cells change
 */
const DeliverablesCell = memo(({ row }) => {
  const task = row.original;
  const deliverables = task.deliverables || [];
  const total = deliverables.length;
  
  // Memoize computed values
  const { completed, allComplete, titleText } = useMemo(() => {
    if (total === 0) return { completed: 0, allComplete: false, titleText: '' };
    
    const completedCount = deliverables.filter(d => d.completed).length;
    return {
      completed: completedCount,
      allComplete: completedCount === total,
      titleText: deliverables.map(d => `${d.completed ? '✓' : '○'} ${d.text || d.name || ''}`).join('\n'),
    };
  }, [deliverables, total]);
  
  if (total === 0) {
    return <span className="table-view__cell-empty">—</span>;
  }

  return (
    <div 
      className={`table-view__deliverables-cell ${allComplete ? 'table-view__deliverables-cell--complete' : ''}`}
      title={titleText}
    >
      <span className="table-view__deliverables-progress">
        {completed}/{total}
      </span>
    </div>
  );
}, (prevProps, nextProps) => {
  const prevTask = prevProps.row.original;
  const nextTask = nextProps.row.original;
  return prevTask.id === nextTask.id && 
         prevTask.deliverables === nextTask.deliverables;
});

export default DeliverablesCell;
